import { Radio } from 'antd';
import { HTMLAttributes } from 'react';
import { useTranslate } from '@tolgee/react';

export interface WaitReplyProps extends HTMLAttributes<HTMLDivElement> {
  waitReply: boolean;
  onWaitReplyChange: (waitReply: boolean) => void;
  disabled?: boolean;
}

function WaitReply(props: WaitReplyProps) {
  const { waitReply, onWaitReplyChange, disabled = false, ...otherProps } = props;

  const { t } = useTranslate();

  return (
    <div {...otherProps}>
      <h5>{t('remind.发起重要提醒时机')}</h5>
      <div>
        <Radio
          disabled={disabled}
          checked={waitReply}
          onChange={({ target: { checked } }) => {
            if (checked) {
              onWaitReplyChange(true);
            }
          }}
        >
          {t('remind.向买家发送挽回话术且买家在48小时内回复消息后，即向客服发起重要提醒')}
        </Radio>
      </div>
      <div>
        <Radio
          disabled={disabled}
          checked={!waitReply}
          onChange={({ target: { checked } }) => {
            if (checked) {
              onWaitReplyChange(false);
            }
          }}
        >
          {t('remind.向买家发送挽回话术后，即向客服发起重要提醒')}
        </Radio>
      </div>
    </div>
  );
}

export default WaitReply;
